<template>
  <a class="button" :class="className" :href="link">
    {{ label }}
  </a>
</template>

<script>
export default {
  name: "HlButton",
  props: ["label", "link", "className"]
};
</script>

<style scoped lang="stylus">
a
  padding: 5px 10px 5px 10px
  border: 1px solid #D1D1D1
  border-radius: 5px
  color: inherit
  font-weight: 600
  text-decoration: none
</style>
